<template>
  <div class="extended-forms">
    <card class="border-card">
      <div class="inputs-sidebar-header d-flex align-items-center justify-content-between"
           @click="isOpen = !isOpen"
           style="cursor: pointer;">
        <h4 class="card-title mt-2 mx-0 font-weight-bold">{{ title }}</h4>
        <i class="fa-regular" :class="isOpen ? 'fa-angle-up' : 'fa-angle-down'"></i>
      </div>

      <collapse-transition>
        <div v-show="isOpen">
          <slot></slot>

          <div class="row mt-3 mb-3 px-2">
            <div class="w-100">
              <base-button
                @click="confirmRegenerate"
                :disabled="disabled || loading"
                :loading="loading"
                type="primary"
                class="btn-fill py-3 px-3 btn_add_link regenerate-btn w-100"
              >
                {{ buttonLabel }}
              </base-button>
            </div>
          </div>

          <div v-if="messages.length" class="skeletonMessages px-2 mb-3">
            <div
              v-for="(line, index) in messages"
              :key="index"
              class="message-line"
            >
              <p>{{ line }}</p>
            </div>
          </div>
        </div>
      </collapse-transition>
    </card>
  </div>
</template>

<script>
import { CollapseTransition } from 'vue2-transitions';
import { MessageBox } from 'element-ui';

export default {
  name: 'ToolInputsSidebar',
  components: {
    CollapseTransition,
  },
  props: {
    title: {
      type: String,
      default: 'Input Fields',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonLabel: {
      type: String,
      default: 'Rigenera',
    },
    messages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    confirmRegenerate() {
      MessageBox.confirm(
        'Attenzione, il nuovo contenuto sostituirà quello attuale.',
        'Conferma rigenerazione',
        {
          confirmButtonText: 'Rigenera',
          cancelButtonText: 'Annulla',
          type: 'warning',
        }
      ).then(() => {
        this.$emit('regenerate');
      }).catch(() => {});
    },
  },
};
</script>

<style scoped>
.skeletonMessages {
  font-size: 12px;
  color: #004583;
  opacity: 0.8;
  font-weight: 700;
}
.skeletonMessages p {
  margin-bottom: 4px;
}
</style>
